import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { Tenant } from "../../domain/models/tenant";
import { TenantRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class GetTenantByIdUsecase implements UseCase<string, Tenant> {

  constructor(private tenantRepository: TenantRepository) {
  }

  execute(params: string): Observable<Tenant> {
    return this.tenantRepository.getTenantById(params);
  }

}